<template>
	<div class="game-dates" :class="{
		'game-dates--has-multiple' : hasMultipleRegions,
	}">

		<div class="game-dates__selector" @click.stop="isOpen = !isOpen">
			<div class="grid grid--g6 grid--s0 grid--auto grid--nowrap grid--middle">
				<div class="grid__item">

					<span class="fonticon fonticon--calendar fs--16c"></span>

				</div>
				<div class="grid__item">

					<template v-if="selectedRegion">
						<div class="game-dates__region mb--2">{{flatRegions[selectedRegion.region].label}}</div>
						<div v-if="game.isReleaseDatePerRegion && selectedRegion.releaseDate" class="game-dates__date">{{selectedRegion.displayReleaseDate ? $options.filters.formatDateShort(selectedRegion.releaseDate) : 'TBD'}}</div>
						<div v-else class="game-dates__date">{{game.displayReleaseDate && game.releaseDate ? $options.filters.formatDateShort(game.releaseDate) : 'TBD'}}</div>
					</template>
					<template v-else-if="!hasRegions">
						<div class="game-dates__region mb--2">Everywhere</div>
						<div class="game-dates__date">{{game.displayReleaseDate && game.releaseDate ? $options.filters.formatDate(game.releaseDate) : 'TBD'}}</div>
					</template>

				</div>
				<div v-if="hasMultipleRegions" class="grid__item grid__item--space hr">

					<span class="fonticon fonticon--arrow--down fs--9"></span>

				</div>
			</div>
		</div>

		<slide-up-down v-if="hasMultipleRegions" class="game-dates__options" :active="isOpen">
			<div v-if="flatRegions[region.region]" v-for="region in game.regions" class="game-dates__option" @click.stop="/* selectedRegion = region; */isOpen = false;">
				<div class="grid grid--g8 grid--s0 grid--auto grid--nowrap grid--middle grid--spread-between">
					<div class="grid__item max-w--100">

						<div class="game-dates__region">{{flatRegions[region.region].label}}</div>

					</div>
					<div class="grid__item">

						<div
							v-if="game.isReleaseDatePerRegion && region.releaseDate"
							class="game-dates__date">{{
								region.displayReleaseDate ? $options.filters.formatDateShort(region.releaseDate) : 'TBD'
							}}</div>
						<div
							v-else
							class="game-dates__date">{{
								game.displayReleaseDate && game.releaseDate ? $options.filters.formatDateShort(game.releaseDate) : 'TBD'
							}}</div>

					</div>
				</div>
			</div>
		</slide-up-down>

	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { find } from 'lodash'

export default {
	name: 'GameDates',
	components: {
	},
	data () {
		return {
			isOpen: false,
			selectedRegion: null,
		}
	},
	props: {
		game: Object,
	},
	computed:
	{
		...mapGetters({
  		'flatRegions': 'app/flatRegions',
		}),
		hasRegions: function()
		{
			return this.game.regions && this.game.regions.length > 0;
		},
		hasMultipleRegions: function()
		{
			return this.hasRegions && this.game.regions.length > 1;
		},
	},
	created: function()
	{
		this.$eventBus.$on('window-click', this.closeAllPopups);
	},
	mounted: function()
	{
		var region = find(this.game.regions, {region: this.$root.userSelectedRegionKey });
		this.selectedRegion = region ? region : (this.hasRegions ? this.game.regions[0] : null);
	},
	beforeDestroy: function()
	{
		this.$eventBus.$off('window-click', this.closeAllPopups);
	},
	methods: {
		closeAllPopups()
		{
			this.isOpen = false;
		},
	}
}
</script>

<style lang="scss">
	@import "src/scss/toolkit";

	$c: ".game-dates";
	#{$c}
	{
		position: relative;
		width: 210px;
		@include extend(lato-bold);
		font-size: rem(11);
		line-height: (12/11);
		@include extend(bgc-pal--white);
		text-transform: uppercase;
		user-select: none;

		&--has-multiple
		{
			box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05);
		}

		&__selector
		{
			padding: rem(12) rem(16) rem(12) rem(10);

			#{$c}--has-multiple &
			{
				cursor: pointer;
				border: 1px solid palette(lightest-grey);
			}
		}

		&__options
		{
			position: absolute;
			top: 100%;
			left: 0;
			right: 0;
			margin-top: -1px;
			z-index: 50;
			border-bottom: 1px solid palette(lightest-grey);
			box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05);
			max-height: 270px;
			overflow-y: scroll;
			-webkit-overflow-scrolling: touch;
		}

		&__option
		{
			padding: rem(16) rem(16) rem(16) rem(16);
			border: 1px solid palette(lightest-grey);
			margin-bottom: -1px;
			@include extend(bgc-pal--white);

			&:last-child
			{
				border-bottom-width: 0;
			}
		}

		&__region
		{
			color: palette(blue);
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/molecules/GameDates.vue